import React from 'react';

export default function TeamMember({
  memberImg,
  memberName,
  memberDesignation,
}) {
  return (
    <div className="cs_team cs_style_1">
      <div className="cs_team_img cs_radius_15 overflow-hidden d-block">
        <img src={memberImg} alt={memberName} />
      </div>
      <div className="cs_team_info">
        <h2 className="cs_fs_29">{memberName}</h2>
        <p className="mb-0">{memberDesignation}</p>
      </div>
    </div>
  );
}
